import { SkeletonPageHeader } from '@/features/_components/skeletons'

export const PersonHeaderSkeleton = () => {
  return (
    <SkeletonPageHeader
      titleWidth="w-48"
      tabs={[{ width: 'w-24' }, { width: 'w-16' }, { width: 'w-20' }, { width: 'w-20' }]}
      showBack
    />
  )
}
